module.exports = __webpack_public_path__ + "img/head_right.9bc6fb70.png";